import React from 'react';
import Alert from 'react-bootstrap/Alert'
import Modal from 'react-bootstrap/Modal'
import 'bootstrap/dist/css/bootstrap.min.css';
import ApiService from './services/ApiService';
import { Bar } from 'react-chartjs-2';
import { withCookies } from 'react-cookie';
import './App.css';

let apiService = new ApiService();

const sendCode = async (msisdn) => {
  let result = await apiService.sendCode(msisdn);
  return result.data;
}

const canVote = async (msisdn) => {
  let result = await apiService.canVote(msisdn);
  return result.data;
}

const checkCode = async (msisdn, code) => {
  let result = await apiService.checkCode(msisdn, code);
  return result.data;
}

const getAllCandidates = async () => {
  let result = await apiService.getAllCandidates();
  if (!!result) {
    return result.data.data;
  }
  return [];
}
const getStatistics = async () => {
  let result = await apiService.getStatistics();
  if (!!result && result.data.success) {
    return result.data.data;
  }
  return [];
}

const shuffle = (array) => {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

const Candidate = ({ fullName, presiId, totalVotes, partido, vote, photo }) => {
  return (
    <div className="card">
      {
        photo === 'none' ? '' : <img src={process.env.PUBLIC_URL + `/${photo}`} className="card-img-top" alt="..." />
      }
      <div className="card-body">
        <h5 className="card-title">{fullName}</h5>
        {
          totalVotes === -1 ?  <p className="card-text">Total de votos: <svg className="bi bi-lock-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <rect width="11" height="9" x="2.5" y="7" rx="2"/>
                <path fillRule="evenodd" d="M4.5 4a3.5 3.5 0 117 0v3h-1V4a2.5 2.5 0 00-5 0v3h-1V4z" clipRule="evenodd"/>
              </svg>
            </p> : <p className="card-text">Total de votos: {totalVotes}</p>
        }
        <p className="card-text">{partido}</p>
      </div>
      <div className="card-footer">
        <button type="button" className="buttonAction btn btn-dark btn-lg btn-block" onClick={() => vote(presiId)} disabled>Votar</button>
      </div>
    </div>
  );
};

const CandidateContainer = ({candidates, vote}) => {
  return ( 
      <div className="card-deck">
      {
        candidates !== undefined ? candidates.map((candidate, idx) => {
          return <Candidate key={idx} fullName={candidate.fullName} photo={candidate.imageUrl} totalVotes={candidate.totalVotes} partido={candidate.partido} presiId={candidate.presiId} vote={vote}  />
        }) : <div>No hay candidatos para votar.</div>
      }
      </div>
  );
}

const Bye = ({presiName, voted, msg}) => {
  if (voted) {
    return (
      <div>
        <Alert variant="success">
          <Alert.Heading>Has votado exitosamente por { presiName }!</Alert.Heading>
          <p>
            Comparte esta página con tus contactos para que ellos también puedan votar.
          </p>
        </Alert>
      </div>
    );
  }
  return (<div>
    <Alert variant="danger" >
        <Alert.Heading>Ups!</Alert.Heading>
        <p>
          {
            msg ? msg : 'Hubo un error registrando tu voto. Disculpa los inconvenientes. Lo más probable es que ya exista un voto con este número.'
          }
        </p>
      </Alert>
  </div>);
}

const VerificationDialog = ({msisdn, onSendCode, msisdnChange, toCheck, onCheckCode, codeTyped, codeTypedChange, loading}) => {
  return (
    <Modal.Dialog>
      <Modal.Header closeButton>
        {
          toCheck ? <Modal.Title>Ya casi terminamos...</Modal.Title> : <Modal.Title>Verifica tu voto (seguro y confiable)</Modal.Title>
        }
      </Modal.Header>

      <Modal.Body>
        {
          loading ? <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div className="spinner-grow" style={{ width: '3rem', height: '3rem' }} role="status">
                          <span className="sr-only">{toCheck ? 'Enviando código...' : 'Verificando...'}</span>
                          </div>{toCheck ? 'Enviando código...' : 'Verificando...'}</div>
                      </div> : toCheck ? <><b>Introduce el código de verificación que has recibido en tu SMS</b>
                      <p>Te enviaremos un código de 4 dígitos a tu móvil.</p>
                      <input type="text" className="form-control" value={codeTyped} onChange={codeTypedChange} maxLength="4" placeholder="Ejemplo: 4546" /> </> 
                   : <> <b>Introduce tu número de teléfono para verificar tu voto.</b>
                      <p>Te enviaremos un código de 4 dígitos a tu móvil.</p>
                      <input type="text" className="form-control" value={msisdn} onChange={msisdnChange} maxLength="10" placeholder="Ejemplo: 8299888135" /></>
        }
      </Modal.Body>

      <Modal.Footer>
        <button disabled={toCheck ? codeTyped.length < 4 : msisdn.length < 10} className="btn btn-primary btn-lg" onClick={ toCheck ?  onCheckCode : onSendCode }>{ toCheck ? 'Confirmar código' : 'Enviar código de verificación'}</button>
      </Modal.Footer>
    </Modal.Dialog>
  );
}


class App extends React.Component  {

  constructor(props) {
    super(props);
    this.state = {
      candidates: [],
      voteSuccess: false,
      hasVoted: false,
      machineIp: undefined,
      loading: true,
      error: false,
      showAlert: false,
      revealDate: new Date('2020/04/25'),
      presiNameVoted: undefined,
      statistics: [],
      successStats: true,
      showVerificationDialog: false,
      msisdn: '',
      codeTyped: '',
      toCheck: false,
      errorMsg: '',
      proceedToVerify: false,
      chartData: {
        labels: [],
        datasets: [{
          label: "Porcentaje de votos por candidato (%)",
          backgroundColor: 'rgb(0, 0, 0, 0.5)',
          borderColor: 'rgb(255, 99, 132)',
          data: [],
        }]
      }
    }
  }

  componentDidMount = async () => {
    let candidates = shuffle(await getAllCandidates());
    let statistics = await getStatistics();
    let candidatePercentages = [];
    let candidateLabels = [];
    let successStats = this.state.successStats;

    let chartData = this.state.chartData;

    let orderedCandidates = [];
    let noneCandidate = undefined;
    for(let i = 0; i < candidates.length; i++) {
      let cand = candidates[i];
      cand.imageUrl = this.getImage(cand.partido);
      if (cand.partido !== '') {
        orderedCandidates.push(cand);

        if (statistics !== undefined && statistics.length > 0) {
          candidateLabels.push(cand.fullName);
          candidatePercentages.push(statistics.find(x => x.candidateId === cand.presiId).percentage)
        }
      } else {
        noneCandidate = cand;
      }
    }

    // Set chart data
    chartData.datasets[0].data = candidatePercentages;
    chartData.labels = candidateLabels;

    if (chartData.labels.length === 0) {
      // Error loading statistics for char
      console.log('Error getting statistics for the chart.');
      successStats = false;
    }

    if ( noneCandidate !== undefined ) {
      orderedCandidates.push(noneCandidate);

      if (statistics !== undefined && statistics.length > 0) {
        candidateLabels.push(noneCandidate.fullName);
        candidatePercentages.push(statistics.find(x => x.candidateId === noneCandidate.presiId).percentage)
      }
    }

    this.setState({
      candidates: orderedCandidates,
      chartData,
      statistics,
      successStats,
      loading: false
    }, () => {
      // this.findMachineIp();
      this.setBurbleHeight(undefined)
    });
  }

  getImage = (partido) => {
    if (partido.toLowerCase().includes('moderno')) {
      return 'abinader.jpeg'
    } else if (partido.toLowerCase().includes('fuerza')) {
      return 'leonel.jpeg'
    } else if (partido.toLowerCase().includes('dominicana')) {
      return 'gonzalo2.jpeg'
    } else if (partido.toLowerCase().includes('alianza')) {
      return 'guillermo.jpeg'
    } else if (partido.toLowerCase() === '') {
      return 'none'
    }
  }

  setVoted = (voteSuccess, presiNameVoted) => {
    this.setState({
      voteSuccess,
      hasVoted: true,
      loading: false,
      presiNameVoted,
      showVerificationDialog: false
    }, () => {
      this.setBurbleHeight('100vh')
    });
  }

  vote = (presiId) => {
    const { cookies } = this.props;
    cookies.set('presiID', presiId, {path: '/'});
    this.setState({
      loading: false,
      showVerificationDialog: true
    });
  }

  displayIp = (fingerPrint) => {
    let index = fingerPrint.indexOf('-router:');
    let ip = fingerPrint.substring(index + 8);

    if (ip === '0.0.0.0') {
      return undefined;
    }

    return ip;
  }

  findMachineIp = async () => {
    let ip = await apiService.findIp();
    let toDisplayIp = this.displayIp(ip);
    if (toDisplayIp === undefined) {
      document.getElementById("ip").innerHTML = 'Deshabilita el plugin Ad Block !';
      this.setState({
        machineIp: ip,
        loading: false,
        error: true,
        errorMsg: 'Seguro tienes plugins en tu navegador que evitan validar tu dispositivo. Intenta desde otro.'
      })
    } else {
      document.getElementById("ip").innerHTML = this.displayIp(ip);
      this.setState({
        machineIp: ip,
        loading: false
      }, () => {
        this.setBurbleHeight(undefined)
      })
    }
  }

  setBurbleHeight = (height) => {
    let rootHeight = document.getElementById('root').offsetHeight;
    let burblesElement = document.getElementById('burbles');

    if (!!height) {
      burblesElement.style.height = height;
    } else {
      burblesElement.style.height = rootHeight + 150 + 'px';
    }
  }

  closeAlert = () => {
    document.getElementById('alert-main').style.hidden = true;
  }

  hideAlert = () => {
    this.setState({
      showAlert: false,
    })
  }

  msisdnChange = (e) => {
    this.setState({
      msisdn: e.target.value
    })
  }

  codeTypedChange = (e) => {
    this.setState({
      codeTyped: e.target.value
    })
  }

  onSendCode = async () => {
    const { msisdn } = this.state;
    const { cookies } = this.props;

    this.setState({
      loading: true
    }, async () => {
      cookies.set('msisdn', msisdn, {path: '/'});

      if (msisdn !== undefined && msisdn.length === 10) {


        // TODO: Before send.... Verify user can vote, to save requests and money
        let canVote = await this.canVote(msisdn);
        console.log('can vote:::', canVote);

        if (canVote) {
          let resp = await sendCode(msisdn);

          let status = resp.data.status;
          let success = resp.success;
    
          console.log(`Sending code if succeeded, if not in aprox. 30 seconds a cancell request will be made.. Status: ${status} Success: ${success}`);
    
          if (status === 'pending' && success) {
            this.setState({
              toCheck: true,
            }, () => {
              setTimeout(() => {
                this.setState({
                  loading: false
                })
              }, 3000);
            });
          } else {
            this.setState({
              loading: false,
              error: true,
              errorMsg: 'No se pudo enviar el código de verificación, intenta votar de nuevo en 5 minutos.',
              showVerificationDialog: false
            });
          }

        } else {
          this.setState({
            loading: false,
            error: true,
            errorMsg: 'No puedes votar dos veces con el mismo número!',
            showVerificationDialog: false
          })
        }

      
      } else {
        this.setState({
          loading: false,
          error: true
        })
      }
    
    });
  }

  onCheckCode = async () => {
    const { codeTyped, msisdn } = this.state;
    const { cookies } = this.props;

    console.log(codeTyped);

    if (codeTyped === undefined) {

    } else {

      let checkResult = await checkCode(msisdn, codeTyped);
      console.log('check:::', checkResult);

      if (checkResult.data.status === 'C' && checkResult.success) {
        let presiId = cookies.get('presiID') || undefined;

        console.log('presiID: ',presiId, '   msisdn: ', msisdn);

        if ( presiId !== undefined && msisdn !== undefined) {
          let votedResult = false;
  
          let result = await apiService.vote(presiId, '1+'+ msisdn);
          if (!!result && result.data.success) {
            votedResult = true
          }
        
          let presi = this.state.candidates.filter(c => c.presiId === presiId)[0];
          console.log(presi);
          this.setVoted(votedResult, presi.fullName);
        }
      } else {
        console.log('Code is not verified!', checkResult);
        this.setState({
          error: true,
          errorMsg: 'No se pudo verificar el código, intémtalo de nuevo en 5 minutos.',
          showVerificationDialog: false
        })
      }
     
    }
  }

  canVote = async () => {
    const { msisdn } = this.state;
    let resp = await canVote(msisdn);

    console.log('vote:::', resp);

    if (resp.success && resp.data.canVote) {
      return true;
    }
    return false;
  }

  render() {
    const { voteSuccess, errorMsg, codeTyped, toCheck, candidates, hasVoted, loading, error, showAlert, presiNameVoted, chartData, successStats, showVerificationDialog, msisdn } = this.state;
    return (
      <>
       <div className="circleWrapper">
              <ul className="circles" id="burbles">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
            </div>

            
            
        <div className="container-fluid">
          <div className="app-wrapper">
            <div>
              <nav className="navbar fixed-top navbar-dark bg-dark">
                <span style={{ color: 'white' }}>
                  <span style={{ fontWeight: '600' }}>Presi2020</span> | Seleccionar candidato preferido | <span id="ip"></span>
                </span>
              </nav>
            
            <div style={{ marginTop: '75px' }}>
              {/* <Countdown
                date={revealDate}
                intervalDelay={0}
                precision={3}
                renderer={props => <RevealCounter total={props.total} />}
              /> */}
               <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: '24px', width: '100%' }}>
                   <div>
                      <span><b>Hemos cerrado las votaciones. </b></span>
                    </div>
                    <div>
                      <span ><i>Gracias por tu voto!</i></span>
                  </div>
              </div>
              {
                showAlert ? <Alert variant={'info'} onClick={this.hideAlert}>
                    Hola! Quizás puedas volver a votar porque hemos reiniciado la encuesta.  o/
                  </Alert> : undefined
              }
              
            </div>
              

              {
                showVerificationDialog ? <VerificationDialog loading={loading} codeTypedChange={this.codeTypedChange} codeTyped={codeTyped} onCheckCode={this.onCheckCode} toCheck={toCheck} msisdnChange={this.msisdnChange} msisdn={msisdn} onSendCode={this.onSendCode} /> : 
                <div style={{ margin: '16px' }}>
                 
                  {
                    loading ? (<div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div className="spinner-grow" style={{ width: '3rem', height: '3rem' }} role="status">
                                <span className="sr-only">Cargando...</span>
                              </div>Cargando...</div>)
                    : error ? <Bye voted={false} msg={errorMsg} /> : hasVoted ? <Bye presiName={presiNameVoted} voted={voteSuccess} /> : <CandidateContainer candidates={candidates} vote={this.vote} />
                  }

                  {
                    (successStats && !hasVoted && !loading && !error ) ?  <div className="char-container">
                      <Bar data={chartData} />
                    </div> : undefined
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default withCookies(App);
